(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_carousel_section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function stripEditorAttributes(el) {
      el.removeAttribute('id');
      Array.prototype.slice.call(el.attributes).forEach(function (attr) {
        if (attr.name.indexOf('data-shopify') === 0 || attr.name === 'data-block-id') {
          el.removeAttribute(attr.name);
        }
      });
      el.querySelectorAll('[id], [data-shopify-editor-block], [data-block-id]').forEach(function (nested) {
        nested.removeAttribute('id');
        Array.prototype.slice.call(nested.attributes).forEach(function (attr) {
          if (attr.name.indexOf('data-shopify') === 0 || attr.name === 'data-block-id') {
            nested.removeAttribute(attr.name);
          }
        });
      });
    }

    function markAsClone(el) {
      stripEditorAttributes(el);
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('tabindex', '-1');
      el.classList.add('carousel-clone');
      return el;
    }

    function getVisibleCount() {
      return window.matchMedia('(max-width: 749px)').matches ? 3 : 4;
    }

    function resetToOriginals(root) {
      var viewport = root.querySelector('.section-content-wrapper');
      if (!viewport) return;
      var track = viewport.querySelector('.carousel-track');
      if (!track) return;
      var reals = Array.prototype.slice.call(track.children).filter(function (el) {
        return !el.classList.contains('carousel-clone');
      });
      reals.forEach(function (el) {
        el.removeAttribute('aria-hidden');
        el.removeAttribute('tabindex');
        viewport.appendChild(el);
      });
      track.remove();
      root.removeAttribute('data-carousel-ready');
    }

    function buildCarousel(root) {
      if (root.getAttribute('data-carousel-ready') === 'true') return;

      var viewport = root.querySelector('.section-content-wrapper');
      if (!viewport) return;

      var originals = Array.prototype.slice.call(viewport.children).filter(function (el) {
        return el.nodeType === 1 && !el.classList.contains('carousel-track');
      });

      if (originals.length === 0) {
        root.setAttribute('data-carousel-ready', 'true');
        return;
      }

      viewport.classList.add('carousel-viewport');

      var track = viewport.querySelector('.carousel-track');
      if (!track) {
        track = document.createElement('div');
        track.className = 'carousel-track';
        originals.forEach(function (item) {
          track.appendChild(item);
        });
        viewport.appendChild(track);
      }

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var n = originals.length;
      var visibleCount = getVisibleCount();

      if (reducedMotion || n <= visibleCount) {
        // Not enough real blocks to justify a loop (or reduced motion is on):
        // show only the real blocks, leave any remaining viewport space empty.
        // No clones, no animation — never fake content to fill the row.
        viewport.style.overflow = reducedMotion ? 'auto' : 'hidden';
        track.classList.remove('is-animating');
        track.style.animationDuration = '';
        root.setAttribute('data-carousel-ready', 'true');
        return;
      }

      viewport.style.overflow = 'hidden';

      var repeat = Math.max(2, Math.ceil((visibleCount * 2) / n));

      var realNodes = Array.prototype.slice.call(track.children);
      for (var r = 1; r < repeat; r++) {
        realNodes.forEach(function (node) {
          track.appendChild(markAsClone(node.cloneNode(true)));
        });
      }

      var baseSet = Array.prototype.slice.call(track.children);
      baseSet.forEach(function (node) {
        track.appendChild(markAsClone(node.cloneNode(true)));
      });

      var secondsPerItem = parseFloat(root.getAttribute('data-seconds-per-item') || '3');
      track.style.animationDuration = secondsPerItem * baseSet.length + 's';
      track.classList.add('is-animating');

      root.setAttribute('data-carousel-ready', 'true');

      root.addEventListener('shopify:block:select', function () {
        track.classList.add('is-paused');
      });
      root.addEventListener('shopify:block:deselect', function () {
        track.classList.remove('is-paused');
      });
    }

    function initAll() {
      document.querySelectorAll('.carousel-section:not([data-carousel-ready="true"])').forEach(buildCarousel);
    }

    function debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () {
          fn.apply(null, args);
        }, wait);
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);

    window.addEventListener(
      'resize',
      debounce(function () {
        document.querySelectorAll('.carousel-section[data-carousel-ready="true"]').forEach(function (root) {
          resetToOriginals(root);
          buildCarousel(root);
        });
      }, 250)
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_carousel_section_2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function stripEditorAttributes(el) {
      el.removeAttribute('id');
      Array.prototype.slice.call(el.attributes).forEach(function (attr) {
        if (attr.name.indexOf('data-shopify') === 0 || attr.name === 'data-block-id') {
          el.removeAttribute(attr.name);
        }
      });
      el.querySelectorAll('[id], [data-shopify-editor-block], [data-block-id]').forEach(function (nested) {
        nested.removeAttribute('id');
        Array.prototype.slice.call(nested.attributes).forEach(function (attr) {
          if (attr.name.indexOf('data-shopify') === 0 || attr.name === 'data-block-id') {
            nested.removeAttribute(attr.name);
          }
        });
      });
    }

    function markAsClone(el) {
      stripEditorAttributes(el);
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('tabindex', '-1');
      el.classList.add('carousel-clone');
      return el;
    }

    function getVisibleCount() {
      return window.matchMedia('(max-width: 749px)').matches ? 3 : 4;
    }

    function resetToOriginals(root) {
      var viewport = root.querySelector('.section-content-wrapper');
      if (!viewport) return;
      var track = viewport.querySelector('.carousel-track');
      if (!track) return;
      var reals = Array.prototype.slice.call(track.children).filter(function (el) {
        return !el.classList.contains('carousel-clone');
      });
      reals.forEach(function (el) {
        el.removeAttribute('aria-hidden');
        el.removeAttribute('tabindex');
        viewport.appendChild(el);
      });
      track.remove();
      root.removeAttribute('data-carousel-ready');
    }

    function buildCarousel(root) {
      if (root.getAttribute('data-carousel-ready') === 'true') return;

      var viewport = root.querySelector('.section-content-wrapper');
      if (!viewport) return;

      var originals = Array.prototype.slice.call(viewport.children).filter(function (el) {
        return el.nodeType === 1 && !el.classList.contains('carousel-track');
      });

      if (originals.length === 0) {
        root.setAttribute('data-carousel-ready', 'true');
        return;
      }

      viewport.classList.add('carousel-viewport');

      var track = viewport.querySelector('.carousel-track');
      if (!track) {
        track = document.createElement('div');
        track.className = 'carousel-track';
        originals.forEach(function (item) {
          track.appendChild(item);
        });
        viewport.appendChild(track);
      }

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var n = originals.length;
      var visibleCount = getVisibleCount();

      if (reducedMotion || n <= visibleCount) {
        // Not enough real blocks to justify a loop (or reduced motion is on):
        // show only the real blocks, leave any remaining viewport space empty.
        // No clones, no animation — never fake content to fill the row.
        viewport.style.overflow = reducedMotion ? 'auto' : 'hidden';
        track.classList.remove('is-animating');
        track.style.animationDuration = '';
        root.setAttribute('data-carousel-ready', 'true');
        return;
      }

      viewport.style.overflow = 'hidden';

      var repeat = Math.max(2, Math.ceil((visibleCount * 2) / n));

      var realNodes = Array.prototype.slice.call(track.children);
      for (var r = 1; r < repeat; r++) {
        realNodes.forEach(function (node) {
          track.appendChild(markAsClone(node.cloneNode(true)));
        });
      }

      var baseSet = Array.prototype.slice.call(track.children);
      baseSet.forEach(function (node) {
        track.appendChild(markAsClone(node.cloneNode(true)));
      });

      var secondsPerItem = parseFloat(root.getAttribute('data-seconds-per-item') || '3');
      track.style.animationDuration = secondsPerItem * baseSet.length + 's';
      track.classList.add('is-animating');

      root.setAttribute('data-carousel-ready', 'true');

      root.addEventListener('shopify:block:select', function () {
        track.classList.add('is-paused');
      });
      root.addEventListener('shopify:block:deselect', function () {
        track.classList.remove('is-paused');
      });
    }

    function initAll() {
      document.querySelectorAll('.carousel-section:not([data-carousel-ready="true"])').forEach(buildCarousel);
    }

    function debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () {
          fn.apply(null, args);
        }, wait);
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);

    window.addEventListener(
      'resize',
      debounce(function () {
        document.querySelectorAll('.carousel-section[data-carousel-ready="true"]').forEach(function (root) {
          resetToOriginals(root);
          buildCarousel(root);
        });
      }, 250)
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee_custom"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('foodie-marquee')) {
    class FoodieMarquee extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          this._onReady = () => { this._onReady = null; this.init(); };
          document.addEventListener('DOMContentLoaded', this._onReady, { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        if (this._onReady) {
          document.removeEventListener('DOMContentLoaded', this._onReady);
          this._onReady = null;
        }
        this.teardown();
      }

      init() {
        if (this._active || this.dataset.animate !== 'true') return;
        this.track = this.querySelector('[data-fmq-track]');
        this.viewport = this.querySelector('[data-fmq-viewport]');
        this.toggle = this.querySelector('[data-fmq-toggle]');
        if (!this.track || !this.viewport) return;
        this._active = true;

        this.mq = window.matchMedia('(max-width: ' + (this.dataset.breakpoint || 749) + 'px)');
        this.schedule = () => {
          if (this._raf) return;
          this._raf = requestAnimationFrame(() => { this._raf = null; this.update(); });
        };
        this.onToggle = () => {
          const paused = this.classList.toggle('is-paused');
          this.toggle.setAttribute('aria-pressed', String(paused));
          this.toggle.textContent = paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
        };

        this.mq.addEventListener('change', this.schedule);
        if (this.toggle) this.toggle.addEventListener('click', this.onToggle);

        const first = this.track.querySelector('.foodie-marquee__group:not([data-fmq-clone])');
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.schedule);
          this.ro.observe(this.viewport);
          if (first) this.ro.observe(first);
        } else {
          window.addEventListener('resize', this.schedule);
        }
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            this.classList.toggle('is-offscreen', !entries[0].isIntersecting);
          });
          this.io.observe(this);
        }
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.schedule);

        this.update();
      }

      teardown() {
        if (!this._active) return;
        this._active = false;
        if (this._raf) cancelAnimationFrame(this._raf);
        this._raf = null;
        if (this.mq) this.mq.removeEventListener('change', this.schedule);
        if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
        window.removeEventListener('resize', this.schedule);
        this.ro = this.io = null;
      }

      makeClone(source) {
        const clone = source.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-fmq-clone', '');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
        return clone;
      }

      update() {
        const first = this.track.querySelector('.foodie-marquee__group:not([data-fmq-clone])');
        if (!first) return;
        const groupWidth = first.getBoundingClientRect().width;
        const viewWidth = this.viewport.clientWidth;
        if (!groupWidth || !viewWidth) return; // hidden: observer will call again when visible

        // Enough copies that the visible window is always covered while shifting by one group.
        const needed = Math.max(2, Math.ceil(viewWidth / groupWidth) + 1);
        const clones = this.track.querySelectorAll('[data-fmq-clone]');
        let count = clones.length;
        while (count + 1 < needed) { this.track.appendChild(this.makeClone(first)); count++; }
        while (count + 1 > needed && count > 1) { clones[count - 1].remove(); count--; }

        const raw = this.mq.matches ? this.dataset.speedMobile : this.dataset.speedDesktop;
        const speed = Math.max(1, Number(raw) || 50); // pixels per second
        this.style.setProperty('--fmq-shift', '-' + groupWidth + 'px');
        this.style.setProperty('--fmq-duration', Math.max(1, groupWidth / speed) + 's');
        this.classList.add('is-ready');
      }
    }
    customElements.define('foodie-marquee', FoodieMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
